module.exports = __webpack_public_path__ + "img/0Q3A6963_L_Foamcore.62d32006.jpg";